<template>
	<div style="background:transparent;box-shadow:none;padding: 0; height: 100%">
		<sbspSalaryFilter :filterList.sync="filterList">
			<el-form-item label="工资月份：" style="margin-right:40px;">
				<div style="display: flex;align-items: center;">
					<el-select v-model="filterList[0].value" placeholder="请选择" style="width:110px;" @change="dateWageChange()">
						<el-option v-for="item in filterList[0].options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-date-picker class="el-date" v-if="filterList[0].value=='92480004'" v-model="wageTime.month" style="width:230px;margin-left:4px;"
					 type="monthrange" range-separator="至" value-format="yyyy-MM" start-placeholder="开始月份" end-placeholder="结束月份">
					</el-date-picker>
				</div>
			</el-form-item>
		</sbspSalaryFilter>
		<div class="boxCon" :class="{'isCollapse':$store.getters.isCollapse}" style="padding-bottom: 0;">
			<!--<el-row style="margin-bottom:10px;text-align:right;">
				<el-button style="color:rgba(255,255,255,1)" type="primary" @click="importJump()">导入</el-button>
			</el-row>-->
			<div class="boxTop">
				<div>
					<span>批次信息</span>
				</div>
				<div>
					<span>工资信息</span>
				</div>
			</div>
		</div>
		<div class="boxCon dataList" v-loading="loading">
      <div v-if="dataLists.length== 0" style="margin: 0 auto;">
        <noData style="margin:40px 0;text-align: center" msg="暂无数据"></noData>
      </div>

			<list v-for="list in dataLists" :list="list" :key="list.createTime">
				<div class="leftButtonCon" style="top: 0;">

					<leftButton v-if="!list.eidtable" title="删除" @click="deleteAction(list)" style="right:-38px;position: absolute;"></leftButton>
					<leftButton title="查看详情" @click="details(list)"></leftButton>
				</div>
			</list>
			<div style="background:#fff;padding:16px 34px 0 0">
				<div class="block">

					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="msgPage.page"
					 :page-sizes="[10, 20, 50, 100]" :page-size="msgPage.limit" layout="total, sizes, prev, pager, next, jumper"
					 :total="msgPage.total">
					</el-pagination>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import sbspSalaryFilter from "@/wage-components/sbs-salary-filter/sbsp-salary-filter.vue"
	import list from "@/wage-components/sbs-salary-card/list.vue"
	import leftButton from "@/wage-components/sbs-salary-card/left-button.vue"
  import noData from "@/wage-components/bsp-noData/bsp-noData.vue"

  import {
		findPageByParams,
		deleteAction
	} from "@/api/wage/batchTemplate.js"
	import {
		queryPmsPayGroupTree
	} from "@/api/wage/payGroup";

	export default {
		name: "approval",
		components: {
			sbspSalaryFilter,
			list,
			leftButton,
      noData
		},
		data() {
			return {
				msgPage: {
					limit: 10,
					page: 1,
					total: 0,
					monthStr: '92480001',
					monthStart: '',
					monthEnd: '',
				},
				wageTime: {
					month: '',
				},
				loading: false,
				dataLists: [
					/*{
					          title:'201912工资',
					          eidtable:true,
					          name:'卫东',
					          createTime:'2018-12-31 11:08:09',
					          //process:['数据准备','薪资审批','付款通知','薪资发放','个税申报','个税缴纳'],
					          currentProcess:1,
					          type:'error',
					          info:['2021-12-31','2022-12-31','2023-12-31',100,100,'工资离职金模板']
					        },{
					          title:'201912工资',
					          eidtable:false,
					          name:'卫东',
					          createTime:'2018-12-31 11:08:09',
					          //process:['数据准备','薪资审批','付款通知','薪资发放','个税申报','个税缴纳'],
					          currentProcess:3,
					          type:'error',
					          info:['2021-12-31','2021-12-31','2021-12-31',100,100,'工资离职金模板']
					        },{
					          title:'201912工资',
					          eidtable:true,
					          name:'卫东',
					          createTime:'2018-12-31 11:08:09',
					          //process:['数据准备','薪资审批','付款通知','薪资发放','个税申报','个税缴纳'],
					          currentProcess:1,
					          type:'error',
					          info:['2021-12-31','2021-12-31','2021-12-31',100,100,'工资离职金模板']
					        },{
					          title:'201912工资',
					          eidtable:true,
					          name:'卫东',
					          createTime:'2018-12-31 11:08:09',
					          //process:['数据准备','薪资审批','付款通知','薪资发放','个税申报','个税缴纳'],
					          currentProcess:2,
					          type:'loading',
					          info:['2021-12-31','2021-12-31','2021-12-31',100,100,'工资离职金模板']
					        },{
					          title:'201912工资',
					          eidtable:true,
					          name:'卫东',
					          createTime:'2018-12-31 11:08:09',
					          //process:['数据准备','薪资审批','付款通知','薪资发放','个税申报','个税缴纳'],
					          currentProcess:1,
					          type:'error',
					          info:['2021-12-31','2021-12-31','2021-12-31',100,100,'工资离职金模板']
					        }*/
				],
				filterList: [{
						text: "工资月份",
						type: 'select-timer',
						value: '92480002',
						name: 'wageMonth',
						options: [{
							value: '92480001',
							label: '当前月'
						}, {
							value: '92480002',
							label: '近三个月'
						}, {
							value: '92480003',
							label: '近一年'
						}, {
							value: '92480004',
							label: '其他'
						}]
					},
					// {
					// 	text: "批次名称",
					// 	type: 'text',
					// 	value: '',
					// 	name: 'batchName'
					// },
          {
            text: "",
            type: 'text',
            value: '',
            name: 'batchName'
          },
					{
						text: "薪酬组",
						type: 'treeSelect',
						value: [],
						multiple: true,
						name: 'groupId',
						defaultGroupProps: {
							children: 'children',
							label: 'groupName',
							value: 'id',
						},
						options: []
					},
					{
						text: "社保月份",
						type: 'timer',
						value: '',
						name: 'socMonth',
						format: 'yyyy-MM',
						pickerType: 'month'
					},
					{
						text: "税金月份",
						type: 'timer',
						value: '',
						name: 'taxMonth',
						format: 'yyyy-MM',
						pickerType: 'month'
					},
					{
						text: "计税类型",
						type: 'select',
						value: [],
						multiple: true,
						name: 'taxType',
						dicts: '9245',
						remNum: "92450002,92450004,92450007"
					}
				]
			};
		},
		watch: {
			filterList: { //深度监听，可监听到对象、数组的变化
				handler(val, oldVal) {
					val.map((item) => {
						if (item.value2) {
							this.$set(this.msgPage, item.name, item.value2);
						} else {
							if (item.value2 == '' && item.value) {
								this.$set(this.msgPage, item.name, item.value.split(','));
							} else {
								this.$set(this.msgPage, item.name, item.value);
							}
						}
					})
					this.msgPage.page = 1;
					if (this.msgPage.wageMonth == '92480004') {
						return;
					}
					console.log(this.msgPage, 222222222)
					this.findPage();
				},
				deep: true //true 深度监听
			},
			wageTime: {
				handler(val, oldVal) {

					let month = val.month;
					this.$set(this.msgPage, 'monthStart', month[0]);
					this.$set(this.msgPage, 'monthEnd', month[1]);
					this.findPage();
				},
				deep: true //true 深度监听
			}

		},

		created() {
			this.filterLists = JSON.parse(JSON.stringify(this.filterList))
			this._queryPmsPayGroupTree() //查询薪酬组树
			this.findPage()
		},
		methods: {
			dateWageChange(val) {
				if (this.filterList[0].value != '92480004') {
					this.$set(this.msgPage, 'monthStart', '');
					this.$set(this.msgPage, 'monthEnd', '');
				}
			},
			importJump() {
				this.$router.push({
					path: '/onetime-upload'
				});
			},
			deleteAction(obj) {
        this.$confirm('确认删除?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(
          ()=>{
            let id = obj.id;
            deleteAction(id).then(res => {
              if (res.data.code == 0) {
                this.$message.success("删除成功");
                this.findPage() //刷新页面
              } else {
                this.$message.error(res.data.msg);

              }
            })
          }
        )

			},
			//获取薪酬组数据
			_queryPmsPayGroupTree() {
				queryPmsPayGroupTree().then(res => {
					let rs = res.data
					if (rs.code == 0) {
						// this.filterList[2].value = [rs.data[0].id]
						this.filterList[2].options = rs.data;
						this.filterLists = JSON.parse(JSON.stringify(this.filterList));
					}
				})
			},
			details(obj) {
				let id = obj.id;
				let wageTmplId = obj.wageTmplId;
				let query = {
					batchId: id,
					templateId:wageTmplId
				}
				console.log("编辑参数query=", query);
				this.$router.push({
					path: '/payrollSettings/wageBatchInfoGroupTable',
					query
				});
			},
			findPage() {
				//默认查询方法
				/*
				*/
				this.loading = true;
				findPageByParams(this.msgPage).then(res => {
          this.msgPage.limit = res.data.size
          this.msgPage.page = res.data.current
          this.msgPage.total = res.data.total
          // this.msgPage.limit = res.data.size
          // this.msgPage.page = res.data.current
          // this.msgPage.total = res.data.total
					// this.$set(this.msgPage, 'limit', res.data.size);
					// this.$set(this.msgPage, 'page', res.data.current);
					// this.$set(this.msgPage, 'total', res.data.total);
					this.dataLists = res.data.records;

					this.loading = false;
				})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
        this.msgPage.limit = val
				// this.$set(this.msgPage, 'limit', val);
        this.findPage();
			},
			handleCurrentChange(val) {
        this.msgPage.page = val
				// this.$set(this.msgPage, 'page', val);
				this.findPage();
			},
		}
	};
</script>

<style scoped>
	.el-date.el-date-editor>>>.el-range__close-icon {
		line-height: 20px;
	}

	.fixed {
		position: fixed;
		z-index: 20;
		width: calc(100vw - 204px);
		box-sizing: border-box;
		transition: .6s;
	}

	.isCollapse {
		width: calc(100vw - 88px);

	}

	.boxCon {
		background: #fff;
		padding: 10px 10px 40px 10px;
	}
  .dataList {
    height: calc(100% - 150px);
    overflow: auto;
  }

	.boxTop {
		display: flex;
		background: rgba(231, 231, 231, 1);
	}

	.boxTop>div:nth-of-type(2) {
		flex-grow: 1;
	}

	.boxTop span {
		display: inline-block;
		height: 34px;
		line-height: 34px;
		font-size: 14px;
		font-weight: 500;
		color: rgba(0, 0, 0, 1);
		text-align: center;
	}

	.boxTop>div:nth-of-type(1) span {
		width: 301px;
		border-right: 2px solid #ddd;
		box-sizing: border-box;
	}

	.boxTop>div:nth-of-type(2) span {
		width: 100%;

	}

	.boxCon:nth-last-of-type(1)>div:nth-last-of-type(2) {
		border-top: 1px solid #ddd;
	}
</style>
